export const MARKETING_PLAY_HOW_IT_WORKS = {
  label: 'Play',
  heading: 'Build your dog’s trusted circle',
  body: 'Connect with compatible dogs and their parents, grow a circle of trusted friends, and arrange playdates with better context around fit, distance, and timing.',
} as const

export const MARKETING_PICKS_HOW_IT_WORKS = {
  label: 'Picks',
  heading: 'Find the right services, care, and products',
  body: 'Discover nearby dog walking, training, grooming, and veterinary care based on your location—plus products surfaced using your dog’s profile.',
} as const
